<template>
    <div >
        <section style="height: 100vh;overflow: hidden;">
            <div style="height: 100vh;position: relative;">
                <el-row class="page-top" type="flex" justify="center" align="center">
                        <el-col :md="6" align="center" style="position: relative;">
                            <el-col :md="24" style="position: absolute;opacity: .2;letter-spacing: 5px;font-weight: bold;">
                                <h1 >NEWS CENTER</h1>
                            </el-col>
                            <el-col :md="24">
                                <h1 style="color: #fff;font-weight: bold;">{{$t('newscenter.toptitle')}}</h1>
                                <h6>NEWS CENTER</h6>
                                <h6>{{$t('newscenter.linfo')}}</h6>
                                
                            </el-col>
                        </el-col>
                </el-row>
                <el-row type="flex" justify="center">
                    <div class="more-page">
                        <p class="iconfont mh-weibiaoti-1-18"></p>
                        <p class="iconfont mh-weibiaoti-1-19 one"></p>
                        <p class="iconfont mh-weibiaoti-1-19 two"></p>
                    </div>
                </el-row>
            </div>
        </section>
        <el-row type="flex" justify="center" class="nlist" id="news">
            <el-col>
                <el-row justify="center" type="flex"> 
                    <el-col :md="4" class="hidden-sm-and-down">
                        <div class="typeMain" ref="newstype"  >
                            <div class="newstype" @click="news(1)" :class="type ==1 ? 'news-active':''">公司动态</div>
                            <div class="newstype" @click="news(2)" :class="type ==2 ? 'news-active':''">员工动态</div>
                            <div class="newstype" @click="news(3)" :class="type ==3 ? 'news-active':''">拜奥动态</div>
                            <div class="newstype" @click="news(5)" :class="type ==5 ? 'news-active':''">红米粒</div>
                        </div>
                    </el-col>
                    <el-col :md="14" :xs="24"  >
                        <el-row style="padding: 0 20px;font-size: 12px;" class="hidden-md-and-up">
                            <el-col :xs="5">
                                <div class="newstype" @click="news(1)" :class="type ==1 ? 'news-active':''">公司动态</div>
                            </el-col>
                            <el-col :xs="5">
                                <div class="newstype" @click="news(2)" :class="type ==2 ? 'news-active':''">员工动态</div>
                            </el-col>
                            <el-col :xs="5">
                                <div class="newstype" @click="news(3)" :class="type ==3 ? 'news-active':''">拜奥动态</div>
                            </el-col>
                            <el-col :xs="5">
                                <div class="newstype" @click="news(5)" :class="type ==5 ? 'news-active':''">红米粒</div>
                            </el-col>
                        </el-row>
                        <el-row style="padding: 20px;">
                            <div v-for="item in list" :key="item.id" class="news" >
                                <div class="img" >
                                    <div class="img-dump" :style="{backgroundImage:'url('+item.imgPath+')'}"></div>
                                </div>
                                <div class="detail">
                                    <div class="title hover-hand"><a target="_blank" :href="item.pagePath">{{item.title}}</a> </div>
                                    <div class="msg hover-hand"> <a target="_blank" :href="item.pagePath">{{item.subContent}}</a></div>
                                </div>
                            </div>
                        </el-row>
                        <el-row type="flex" justify="center" style="margin-top: 30px;">
                            <el-pagination
                              @current-change="goCurrent"
                              :current-page="page.currentPage"
                              :page-size="page.pageSize"
                              background
                              layout="prev, pager, next"
                              :total="page.total"
                              style="--el-color-primary: red"
                               v-if="bPageShow">
                            </el-pagination>
                        </el-row>
                        
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import axios from 'axios'
    export default{
        data() {
            return{
                list:[],
                page:{
                    currentPage:1,
                    total:1,
                    pageSize:5
                },
                type:1,
                idx:1,
                bPageShow:false,
                top:0
            }
        },
        computed:{
            fix(){
                return true
            }
        },
        created() {
            //let aid = this.$route.query.id;
            this.newslist(1,1)
        },
        mounted() {
           window.addEventListener('scroll', this.handleScrollx, true)
        },
        methods:{
            handleScrollx(){
                 // //console.log('滚动高度', window.pageYOffset)
                 // this.top = this.$refs.newstype.getBoundingClientRect().top
                 // console.log('距离顶部高度', this.$refs.newstype.getBoundingClientRect().top)
                 // console.log('距离底部高度', this.$refs.newstype.getBoundingClientRect().bottom)
            },
            goCurrent(val){
                let tp = this.type
                let newsDiv = document.getElementById('news')
                newsDiv.scrollIntoView({ behavior: 'smooth' });
                this.newslist(tp,val)
            },
            onHover(idx){
                //console.log(idx)
                this.idx = idx
            },
            redirect(id)
            {
                window.open("/newsinfo?id="+id,'_blank')
            },
            news(type){
               
               this.bPageShow = false
               this.page.currentPage = 1
               this.type = type
               this.newslist(type,1)
               
            },
            newslist(type,pageNum){
                axios.get('https://www.drmums.com/article/page/'+type+'?pageNum='+pageNum+'&pageSize=5').then(
                //this.$axios.get('http://localhost:8080/article/page/'+type+'?pageNum='+pageNum+'&pageSize=5').then(
                  res=>{
                      console.log(res.data.total)
                      this.list = res.data.list
                      this.page.total = res.data.total
                      this.page.pageSize = res.data.pageSize
                      //document.title = this.article.title
                      if(this.list.length > 0){
                          this.bPageShow = true
                      }
                      
                })
            }
        }
    }
</script>

<style lang="scss">
    @import '../assets/mh.scss';
    // .typeMain{
    //     position: fixed;
    //     top: 200px;
    //     z-index: 99;
    // }
    a {
      text-decoration: none; /* 去掉下划线 */
      color: inherit; /* 继承父元素颜色，状态不变 */
    }
    a:hover {
      color: none; /* 悬停时的颜色 */
    }
    a:active,
    a:focus {
      outline: none; /* 去掉点击时的虚线框 */
      color: #BA4D48; /* 点击时的颜色 */
    }
    .newstype{
        &+.newstype{
            margin-top: 20px;
        }
    }
    .nlist{
        padding: 30px 0;margin-top: 100px;
        @media only screen and (max-width:900px){
          padding: 10px 0;margin-top: 20px;
        }
    }
    .news-active{
        color: #BA4D48;
        &::before{
            content: '⊙';
        }
    }
    .news{
        display: flex;
        flex-direction: row;
        transition: all 0.5s;
        border-radius: 5px;
        overflow: hidden;
        box-shadow: 0px 0px 2px #d1d1d1;
        &:hover{
            box-shadow: 0px 0px 8px #acacac;
            .img{
                .img-dump{
                    transform: scale(1.2) translateZ(0);
                }
            }
        }
        .img{
            height: 140px;
            width: 210px;
            min-width: 210px;
            
            overflow: hidden;
            
            .img-dump{
                height: 140px;
                width: 210px;
                min-width: 210px;
                background-size: cover;
                background-position: center center;
                transition: all 0.5s;
            }
            @media only screen and (max-width:900px){
              height: 80px;
              width: 120px;
              min-width: 120px;
              
              overflow: hidden;
              
              .img-dump{
                  height: 80px;
                  width: 120px;
                  min-width: 120px;
                  background-size: cover;
                  background-position: center center;
                  transition: all 0.5s;
              }
            }
        }
        
        .detail{
            padding:20px;
            display: flex;
            flex-direction: column;
            @media only screen and (max-width:900px){
              .title{
                  font-size: 12px;
              }
              .msg{
                  font-size: 8px;
              }
            }
            @media only screen and (min-width:900px){
              .title{
                  font-size: 24px;
              }
              .msg{
                  font-size: 16px;color: #878080;
              }
            }
        }
        &+.news{
            margin-top: 20px;
        }
    }
    .page-top{
        height: 100vh;
        width: 100vw;
        position: relative;
        background-image: url('https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/pgtp/top.jpg');
        background-position: center center;
        background-size: cover;
        align-items: center;
        .page-title{
            height: 100vh;
            align-items: center;
            display: flex;
            
        }
        h1{
            color: #fff;
            font-weight: bold;
        }
        h6{
            &+h6{
               border-top: 1px solid #acacac; 
               letter-spacing: 3px;
            }
            color: #fff;
            padding: 20px 0;
        }
    }
    
    
</style>